/**
 * Renderable clinician-photo grammar shared by care-team presentation and
 * welcome-pool preview faces.
 */
export const careTeamPhotoUrlShape =
  /^https:\/\/[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*(?::\d+)?(?:[/?#]\S*)?$/;

export function isRenderableCareTeamPhotoUrl(value: string): boolean {
  return careTeamPhotoUrlShape.test(value);
}
